import { Link } from "@tanstack/react-router";
import * as React from "react";

export interface SportCardProps {
  imageSrc: string;
  imageAlt: string;
  title: string | React.ReactNode;
  href?: string;
}

/**
 * SportCard - A reusable card component for displaying sport/activity items
 *
 * Features:
 * - Icon display with hover scale animation
 * - Background color transition on hover
 * - Flexible title support (string or JSX for line breaks)
 * - Optional navigation with TanStack Router Link
 * - Consistent styling with Tennis Gourmet design system
 * - Full accessibility support with proper focus states
 */
export function SportCard({ imageSrc, imageAlt, title, href }: SportCardProps) {
  const cardContent = (
    <div className="tg-sport-card group">
      <div className="tg-sport-card__icon-container group-hover:bg-tennis-800 overflow-hidden group-focus-visible:ring-4 group-focus-visible:ring-white">
        <img
          src={imageSrc}
          alt={imageAlt}
          className="tg-sport-card__icon xl:group-hover:scale-110"
        />
      </div>
      <p className="tg-sport-card__title tg-h4 text-center">{title}</p>
    </div>
  );

  // If href is provided, wrap in Link component
  if (href) {
    return (
      <Link to={href} className="tg-sport-card__link group focus-visible:outline-none">
        {cardContent}
      </Link>
    );
  }

  // Return unwrapped content for non-clickable cards
  return cardContent;
}
